<header
    class="navbar navbar-expand-lg fixed-top bg-default d-flex justify-content-between align-items-center px-3 py-0 border-bottom"
    style="height: 42px;">

    <!-- bars and brand  -->
    <div class="d-flex justify-content-between align-items-center">
        <!-- Toggle menu Bar -->
        <div class="bar">
            <a class="icon-toggle-side-menu cursor-pointer mr-3" (click)="clickbar()" pTooltip="Menu"
                tooltipPosition="{{lang==='ar'? 'right':'left'}}">
                <i class="las la-bars fs-22 arco-primary-text"></i>
            </a>
        </div>
        <!-- app launcher in web  -->
        <div class="app-luncher-web">
            <div class="dropdown">
                <button class="btn p-0 bg-transparent dropdown-toggle border-0 app-luncher-dropdown mr-3" type="button"
                    id="triggerId" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                    pTooltip="{{'helpers.labels.arcoSystems' | translate}}"
                    tooltipPosition="{{lang==='ar'? 'right':'left'}}">
                    <!-- <i class="socicon-coderwall arco-primary-text fs-16" id="icon"></i> -->
                    <!-- <i class="las la-braille arco-primary-text fs-30" style="width: 18px; vertical-align: initial;"></i> -->
                    <img src="./itcores-fw/assets/images/launcher-icon.png" class="launcher-icon" id="icon" alt=""
                        style="width: 18px; vertical-align: initial;">
                </button>
                <div class="dropdown-menu app-luncher-drop" (click)="preventClose($event)" aria-labelledby="triggerId">
                    <div class="app">
                        <app-app-launcher [excludeModuleId]="excludeModuleId"></app-app-launcher>
                    </div>
                </div>
            </div>
        </div>
        <!-- Logo -->
        <a class="navbar-brand p-0">
            <div class="d-flex align-items-center">
                <img src="./assets/icons/android-chrome-512x512.png" routerLink="/main"
                    class="mr-1 d-block cursor-pointer logo-img" width="30"
                    pTooltip="{{'helpers.labels.arcoHomePage' | translate}}" tooltipPosition="bottom">
                <span class="d-block logo-text fs-30 arco-primary-alt-text">
                    <span class="fs-11 bg d-md-inline-block d-none text-white"
                        style="padding: 2px 4px; border-radius: 3px; vertical-align: middle;">
                        <span>{{'helpers.labels.sharedModule' | translate}}</span>
                    </span>
                </span>
            </div>
        </a>
    </div>

    <!-- Search in web view -->
    <!-- <div class="d-flex align-items-center search-profile-web"> -->
    <!-- Search -->
    <!-- <div class="d-flex align-items-center search-form"> -->
    <!-- <form [formGroup]="form" class="d-flex mx-2 global-search"> -->

    <!-- select target -->

    <!-- <p-autoComplete class="form-control autocomplete-form-control search-form-control-select black-alt-text"
          field="name" [suggestions]="[]" id="target" placeholder="{{'enums.all' | translate}}" [forceSelection]="true"
          [size]="30" [minLength]="1" [dropdown]="true">
          <ng-template let-target pTemplate="item">
            <div class="ui-helper-clearfix">
              <div>
                {{ target.name }}
              </div>
            </div>
          </ng-template>
        </p-autoComplete> -->
    <!-- search key -->
    <!-- <p-autoComplete class="form-control autocomplete-form-control search-form-control-autocomplete black-alt-text"
          field="title" id="searchKey" [size]="30" [minLength]="1" [dropdown]="true"
          placeholder="{{'helpers.buttons.searchButton' | translate}}">
          <ng-template let-searchField pTemplate="item">
            <div class="ui-helper-clearfix p-2" style="border-bottom:1px solid #ebebeb;">
              <span>
                {{ searchField.title }}
              </span>
              <span class="fs-11 details-text">(in {{ searchField.name }})</span>
            </div>
          </ng-template>
        </p-autoComplete> -->
    <!-- </form>

    </div>
  </div> -->

    <!-- profile, logout -->
    <div class="d-flex align-items-center">
        <!-- seeting Alert -->
        <div class="dropdown setting mx-2"> 
            <button class="btn bg-transparent p-0 dropdown-toggle rounded-circle" type="button" id="settingId"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                pTooltip="{{'helpers.labels.systemSettings' | translate}}"
                tooltipPosition="{{lang==='ar'? 'right':'left'}}">
                <i class="las la-palette fs-20" aria-hidden="true"></i>


            </button>
            <div class="dropdown-menu dropdown-menu-right nice-scroll" (click)="preventClose($event)"
                aria-labelledby="settingId">
                <p class="px-2 mb-1 fs-14 font-weight-bold text-left">{{'helpers.labels.chooseTheme' | translate}}</p>
                <a class="dropdown-item py-1 px-3 text-left cursor-pointer" href="javascript:;">
                    <p-radioButton name="customerMode" data-color="light" (click)="customerModeChanged('light'); "
                        [(ngModel)]="isColor" value="light" label="light " class="pr-2">
                    </p-radioButton>
                </a>

                <a class="dropdown-item py-1 px-3 text-left cursor-pointer">
                    <p-radioButton name="customerMode" data-color="dark" (click)="customerModeChanged('dark');"
                        [(ngModel)]="isColor" value="dark" label="dark " class="pr-2">
                    </p-radioButton>
                </a>
                <!-- <a (click)="customerModeChanged()" class="dropdown-item py-1 px-3" href="javascript:;">
              <i class="las la-fill-drip lang-icon mr-2"></i>
              {{isColor==='light'? "dark mode" : "light mode"}}
            </a> -->

            </div>
        </div>
        <!-- Notification Alert -->
        <!-- <div class="dropdown notification mx-3">
      <button class="btn bg-transparent p-0 dropdown-toggle rounded-circle arco-primary-border" type="button" id="triggerId" data-toggle="dropdown"
        aria-haspopup="true" aria-expanded="false"
         pTooltip="{{'helpers.labels.systemNotifications' | translate}}""
          tooltipPosition="{{lang==='ar'? 'right':'left'}}" >
        <i (click)="getUserNotifications()" [ngClass]="{'': !userNotificationsCount }"
          class="las la-bell arco-primary-text fs-20" aria-hidden="true"></i>
        <span *ngIf="userNotificationsCount && userNotificationsCount !== null && userNotificationsCount > 0"
          class="position-absolute notification-num  text-white box-shadow-2 text-center align-middle rounded-circle">
          {{ userNotificationsCount }}
        </span>
      </button>
      <div class="dropdown-menu dropdown-menu-right pt-0 nice-scroll" aria-labelledby="triggerId">
        <app-notification-alert></app-notification-alert>
      </div>
    </div> -->
        <!-- User Info -->
        <div class="dropdown username mx-0">
            <button class="btn bg-transparent p-0 fs-13 black-alt-text dropdown-toggle d-flex align-items-center"
                type="button" id="triggerId" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <img src="./itcores-fw/assets/images/avatar-lg.png" width="30" height="30" alt=""
                    class="rounded-circle mr-2 arco-primary-border">
                {{currentUser?.UserName}}
            </button>
            <div class="dropdown-menu p-0" aria-labelledby="triggerId">
                <a (click)="changeLang()" class="dropdown-item py-1 px-3" href="javascript:;">
                    <i class="las la-globe lang-icon mr-2"></i>
                    {{translate.currentLang==='ar'? "English" : "العربية"}}
                </a>
                <a class="dropdown-item py-1 px-3 cursor-pointer" (click)="logout()">
                    <i class="las la-power-off mr-2"></i>
                    {{'helpers.messages.logout'| translate}}
                </a>
            </div>
        </div>
    </div>

</header>